export const timeSpanToDecimal = (time: string): number => {
  const [hours, minutes] = time.split(':').map(Number)

  const decimalHours = hours + minutes / 60

  return parseFloat(decimalHours.toFixed(2))
}
